import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text, TextInput } from 'grommet';
import { Checkmark } from 'grommet-icons';
import { AppButton, CopyButton } from '@Components/Control';
import { useAppTheme } from '@Components/Context';

const Step7GeneratedLink = ({
  prefillResult = null, onCreateAnother,
}) => {
  const { theme } = useAppTheme();
  const { page, button } = theme;
  const url = prefillResult?.url || '';

  return (
    <Box gap="1.25rem" align="start">
      <Box direction="row" align="center" gap="0.5rem">
        <Box
          round="full"
          background="var(--app-success)"
          pad="0.25rem"
          flex={false}
        >
          <Checkmark size="1rem" color="white" />
        </Box>
        <Text size="1.25rem" weight={700} color={page.primaryText}>
          Onboarding link created successfully
        </Text>
      </Box>
      <Box gap="0.5rem" width="100%">
        <Box gap="0.5rem" margin={{ bottom: '0.5rem' }}>
          <Text size="1rem" weight={600} color={page.primaryText}>
            The following link is ready to be shared with the customer. They can use it
            to complete the onboarding process and gain access to the CMS.
          </Text>
          <Text size="1rem" weight={600} color={page.primaryText}>
            <b>Please make sure to copy the URL before navigating away from this page.</b>
          </Text>
        </Box>
        <Text size="0.85rem" weight={600} color={page.primaryText}>
          Onboarding URL
        </Text>
        <Box direction="row" gap="0.5rem">
          <Box width="85%" round="var(--app-radius)" background="var(--page-input-bg)">
            <TextInput
              readOnly
              value={url}
              onClick={(e) => e.target.select()}
              style={{
                fontFamily: 'monospace',
                borderRadius: 'var(--app-radius)',
                background: 'transparent',
                fontSize: '0.85rem',
              }}
            />
          </Box>
          <CopyButton
            value={url}
            iconSize="1.25rem"
            bgColor={button.primaryBg}
            color={button.primaryText}
          />
        </Box>
        {prefillResult?.onboardingId && (
          <Text size="0.85rem" color={page.secondaryText}>
            Onboarding ID:&nbsp;
            {prefillResult.onboardingId}
          </Text>
        )}
      </Box>
      <AppButton
        overrideHover
        level="tableControls"
        width="fit-content"
        bgColor={button.primaryBg}
        color={button.primaryText}
        label="Create another"
        onClick={onCreateAnother}
      />
    </Box>
  );
};

Step7GeneratedLink.propTypes = {
  prefillResult: PropTypes.shape({
    url: PropTypes.string,
    onboardingId: PropTypes.string,
  }),
  onCreateAnother: PropTypes.func.isRequired,
};

export default Step7GeneratedLink;
